module.exports = __webpack_public_path__ + "fonts/Formular-MediumItalic.de70f52.woff2";